// extracted by mini-css-extract-plugin
export default {"exit":"exitTrade_exit__YQgU+","form_exit":"exitTrade_form_exit__Jq8DQ newTrade_form_enter__xb6Nr","input_wrap":"exitTrade_input_wrap__tYwPn"};